import React, { useEffect, useState } from "react";

const Updates = () => {
  const [updates, setUpdates] = useState([]);
  const [showDialog, setShowDialog] = useState(false);
  const [newContent, setNewContent] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchUpdates = async () => {
    setLoading(true);
const token = localStorage.getItem("authToken");

    try {
      const res = await fetch("https://api.pharmacegroup.co.uk/getUpdates", {
        method: "GET",
        headers: { "Content-Type": "application/json",
  "Authorization": `Bearer ${token}` },
      });
      const data = await res.json();
      setUpdates(data.updates || []);
    } catch (err) {
      console.error("Error fetching updates:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUpdates();
  }, []);

  const handleSave = async () => {
    if (!newContent.trim()) return;
const token = localStorage.getItem("authToken");

    try {
      await fetch("https://api.pharmacegroup.co.uk/addUpdate", {
        method: "POST",
        headers: { "Content-Type": "application/json",
  "Authorization": `Bearer ${token}` },
        body: JSON.stringify({ content: newContent }),
      });
      setShowDialog(false);
      setNewContent("");
      fetchUpdates();
    } catch (err) {
      console.error("Error saving update:", err);
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <h2>Updates</h2>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <table border="1" cellPadding="8" style={{ width: "100%", marginBottom: "20px" }}>
          <thead>
            <tr>
              <th>Date & Time</th>
              <th>Content</th>
            </tr>
          </thead>
          <tbody>
            {updates
              .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
              .map((update) => (
                <tr key={update._id}>
                  <td>
                    {new Date(update.createdAt).toLocaleString("en-GB", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "2-digit",
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </td>
                  <td>{update.content}</td>
                </tr>
              ))}
          </tbody>
        </table>
      )}

      <button onClick={() => setShowDialog(true)}>Add New</button>

      {showDialog && (
        <div style={{ marginTop: "20px" }}>
          <textarea
            rows="4"
            cols="50"
            placeholder="Enter update content..."
            value={newContent}
            onChange={(e) => setNewContent(e.target.value)}
          />
          <br />
          <button onClick={() => setShowDialog(false)}>Cancel</button>
          <button onClick={handleSave} style={{ marginLeft: "10px" }}>
            Save
          </button>
        </div>
      )}
    </div>
  );
};

export default Updates;
